import { API_ENDPOINTS } from "@/constants/api";
import { http } from "@/lib/http-client";
import { unwrapData } from "@/lib/api-response";
import type {
  MyPermissions,
  PermissionMatrix,
  PermissionMatrixQuery,
  RolePermissionBulkInput,
  UserPermissionBulkInput,
  UserPermissions,
} from "@/types/permission";

export const permissionsService = {
  async getMatrix(query?: PermissionMatrixQuery): Promise<PermissionMatrix> {
    const response = await http.get(API_ENDPOINTS.PERMISSIONS.MATRIX, {
      params: query,
    });
    return unwrapData<PermissionMatrix>(response);
  },

  async updateRoleTemplates(payload: RolePermissionBulkInput): Promise<void> {
    await http.put(API_ENDPOINTS.PERMISSIONS.MATRIX_ROLES, payload);
  },

  async getMyPermissions(): Promise<MyPermissions> {
    const response = await http.get(API_ENDPOINTS.PERMISSIONS.ME);
    return unwrapData<MyPermissions>(response);
  },

  async getUserPermissions(userId: string): Promise<UserPermissions> {
    const response = await http.get(API_ENDPOINTS.PERMISSIONS.USER(userId));
    return unwrapData<UserPermissions>(response);
  },

  async updateUserPermissions(
    userId: string,
    payload: UserPermissionBulkInput,
  ): Promise<void> {
    await http.put(API_ENDPOINTS.PERMISSIONS.USER(userId), payload);
  },
};
